import React from "react";

import useHome from "../hooks/useHome";
import { isVideo } from "../helpers/isVideo";

const BannerPub = ({ idProducto }) => {
  const { banners } = useHome();
  const arrayBanner = banners?.filter(
    (banner) =>
      banner?.section?.includes(idProducto) && banner?.deleted === false
  );
  return (
    <>
      {arrayBanner?.map((banner, index) => (
        <article
          id="banner-pub"
          className="institucional__bg-start bg-fullpage foto my-3"
          aria-label="Presentación de Institucional de Tensolite"
          key={index}
        >
          {isVideo(banner?.image_desktop[0]?.url) ? (
            <video
              src={banner?.image_desktop[0]?.url}
              className="img-responsive height-banner"
              controls
            />
          ) : (
            <picture>
              <img
                media="(orientation: portrait) and (max-width: 767px)"
                srcSet={
                  banner.image_tablet
                    ? banner.image_tablet[0]?.url
                    : banner.image_tablet
                }
                alt={
                  banner.image_tablet
                    ? banner.image_tablet[0]?.alt
                    : banner?.title
                }
                className="img-responsive height-banner"
                title={banner?.title}
                loading="lazy"
              />
              <img
                media="(orientation: landscape) and (max-width: 767px)"
                srcSet={
                  banner.image_desktop
                    ? banner.image_desktop[0]?.url
                    : banner.image_desktop
                }
                alt={
                  banner.image_desktop
                    ? banner.image_desktop[0]?.alt
                    : banner?.title
                }
                className="img-responsive height-banner"
                title={banner?.title}
                loading="lazy"
              />
              <img
                className="img-responsive height-banner"
                src={
                  banner.image_desktop
                    ? banner.image_desktop[0]?.url
                    : banner.image_desktop
                }
                alt={
                  banner.image_desktop
                    ? banner.image_desktop[0]?.alt
                    : banner?.title
                }
                title={banner?.title}
                loading="lazy"
              />
            </picture>
          )}
          <div className="card-info mb-4">
            <div className="cuadrado-azul"></div>
            <p className="parrafo-tecnico">{banner?.body}</p>
            <button className="settings_button-pleno bg-p-primary_2">
              <a href={banner?.link}>Contacto</a>
            </button>
          </div>
        </article>
      ))}
    </>
  );
};

export default BannerPub;
